export const HOW_IT_WORKS_TITLE = "🤔 Как работает биржа заданий Boostclick?";

// Константы для исполнителей
export const STEP2_TITLE_LOOKING_PERFORMER = "Сервис передает задачу исполнителям через партнера";
export const STEP2_DESCRIPTION_LOOKING_PERFORMER  = "Сценарии автоматически формируются системой, затем задача передается через API подрядчику, который ищет подходящих исполнителей";
// Константы для слушателей
export const STEP2_TITLE_LOOKING_LISTENER = "Сервис передает задачу слушателям через партнера";
export const STEP2_DESCRIPTION_LOOKING_LISTENER = "Сценарии автоматически формируются системой, затем задача передается через API подрядчику, который ищет подходящих слушателей";

export const STEP3_TITLE_CHECK_PAY_REPORT = "Вы проверяете отчет и оплачиваете работу";
export const STEP3_DESCRIPTION_CHECK_PAY_REPORT = "Вы принимаете отчет или отклоняете, если он составлен некорректно. Оплата — только за выполненное и принятое задание.";
